import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetMapaTrazabilidad = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/movimientos-inventario/reportes/individual/grafica/etiqueta-serial`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
      getMapaTrazabilidadMutation: mutation.mutate,
    };
}